import { api, API, getToken } from "./api";

export const MAX_FILE_MB = 100;

export const fileUrl = (f, { download = false } = {}) => `${API}${f.url}?auth=${getToken()}${download ? "&dl=true" : ""}`;

export const fmtBytes = (n) => {
  if (n == null) return "";
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(n < 10240 ? 1 : 0)} KB`;
  if (n < 1024 * 1024 * 1024) return `${(n / (1024 * 1024)).toFixed(1)} MB`;
  return `${(n / (1024 * 1024 * 1024)).toFixed(2)} GB`;
};

export const uploadFile = async (file, { conversationId, onProgress, signal } = {}) => {
  if (file.size > MAX_FILE_MB * 1024 * 1024) throw new Error(`"${file.name}" is larger than ${MAX_FILE_MB} MB`);
  if (!file.size) throw new Error(`"${file.name}" is empty`);
  const { data: init } = await api.post("/files/upload/init", { filename: file.name, content_type: file.type || "application/octet-stream", size: file.size, conversation_id: conversationId || null }, { signal });
  const { upload_id, chunk_size } = init;
  let sent = 0;
  for (let index = 0; index * chunk_size < file.size; index++) {
    const blob = file.slice(index * chunk_size, Math.min(file.size, (index + 1) * chunk_size));
    await api.put(`/files/upload/${upload_id}/chunk`, blob, {
      params: { index }, signal, headers: { "Content-Type": "application/octet-stream" },
      onUploadProgress: (e) => onProgress?.(Math.min(0.99, (sent + (e.loaded || 0)) / file.size)),
    });
    sent += blob.size;
    onProgress?.(Math.min(0.99, sent / file.size));
  }
  const { data } = await api.post(`/files/upload/${upload_id}/complete`, null, { signal });
  onProgress?.(1);
  return data;
};

export const cancelUpload = (uploadId) => api.delete(`/files/upload/${uploadId}`).catch(() => {});
